<template>
  <svg
    viewBox="0 0 140 120"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    class="size-full"
  >
    <!-- Background blob -->
    <ellipse
      cx="70"
      cy="62"
      rx="62"
      ry="44"
      fill="currentColor"
      opacity="0.04"
      stroke="none"
    />

    <!-- Road surface -->
    <path
      d="M4 82 Q35 78 70 80 Q105 82 136 78"
      fill="currentColor"
      opacity="0.05"
      stroke="none"
    />
    <path
      d="M4 82 Q35 78 70 80 Q105 82 136 78"
      opacity="0.12"
      stroke-width="1"
    />

    <!-- Road dashes -->
    <line
      x1="20"
      y1="80"
      x2="28"
      y2="79.5"
      opacity="0.1"
      stroke-width="1.5"
    />
    <line
      x1="52"
      y1="79.5"
      x2="60"
      y2="80"
      opacity="0.1"
      stroke-width="1.5"
    />
    <line
      x1="86"
      y1="80.5"
      x2="94"
      y2="80"
      opacity="0.1"
      stroke-width="1.5"
    />
    <line
      x1="112"
      y1="79.5"
      x2="120"
      y2="79"
      opacity="0.1"
      stroke-width="1.5"
    />

    <!-- Trailer body -->
    <rect
      x="8"
      y="42"
      width="36"
      height="26"
      rx="4"
      ry="4"
      stroke-width="2"
    />
    <rect
      x="8"
      y="42"
      width="36"
      height="26"
      rx="4"
      ry="4"
      fill="currentColor"
      opacity="0.05"
      stroke="none"
    />

    <!-- Trailer horizontal detail -->
    <line
      x1="8"
      y1="52"
      x2="44"
      y2="52"
      opacity="0.15"
      stroke-width="1"
    />

    <!-- Trailer strap/securing marks -->
    <line
      x1="16"
      y1="44"
      x2="16"
      y2="50"
      opacity="0.12"
      stroke-width="1"
    />
    <line
      x1="26"
      y1="44"
      x2="26"
      y2="50"
      opacity="0.12"
      stroke-width="1"
    />
    <line
      x1="36"
      y1="44"
      x2="36"
      y2="50"
      opacity="0.12"
      stroke-width="1"
    />

    <!-- Trailer rear reflectors -->
    <rect
      x="9"
      y="60"
      width="3"
      height="3"
      rx="0.5"
      fill="currentColor"
      opacity="0.1"
      stroke-width="1"
    />
    <rect
      x="9"
      y="54"
      width="3"
      height="3"
      rx="0.5"
      fill="currentColor"
      opacity="0.1"
      stroke-width="1"
    />

    <!-- Trailer wheel -->
    <circle
      cx="26"
      cy="68"
      r="7"
      stroke-width="2"
    />
    <circle
      cx="26"
      cy="68"
      r="3.5"
      stroke-width="1.5"
    />
    <circle
      cx="26"
      cy="68"
      r="1.2"
      fill="currentColor"
      opacity="0.3"
      stroke="none"
    />

    <!-- Trailer mudguard -->
    <path
      d="M18 62 Q26 58 34 62"
      opacity="0.2"
      stroke-width="1.5"
    />

    <!-- Tow bar -->
    <line
      x1="44"
      y1="60"
      x2="58"
      y2="60"
      stroke-width="2"
    />

    <!-- Hitch coupling -->
    <circle
      cx="58"
      cy="60"
      r="2.5"
      fill="currentColor"
      opacity="0.1"
      stroke-width="1.5"
    />

    <!-- Car body — facing right -->
    <path
      d="M58 68
         C58 64 59 61 62 59
         L66 54
         L72 46
         C73 43 76 41 79 40
         L91 40
         C94 40 97 42 98 44
         L104 52
         L108 54
         C111 56 113 59 113 62
         L113 68"
      stroke-width="2.5"
    />
    <path
      d="M58 68
         C58 64 59 61 62 59
         L66 54
         L72 46
         C73 43 76 41 79 40
         L91 40
         C94 40 97 42 98 44
         L104 52
         L108 54
         C111 56 113 59 113 62
         L113 68
         L58 68 Z"
      fill="currentColor"
      opacity="0.06"
      stroke="none"
    />

    <!-- Car roof -->
    <path
      d="M74 46 L80 40.5 L93 40 L100 45"
      stroke-width="2"
    />

    <!-- Car windshield -->
    <path
      d="M76 46 L82 41 L90 40.5 L90 46 Z"
      fill="currentColor"
      opacity="0.08"
    />

    <!-- Car rear window -->
    <path
      d="M92 40.5 L96 41 L99 44 L93 46 Z"
      fill="currentColor"
      opacity="0.08"
    />

    <!-- Window divider -->
    <line
      x1="91"
      y1="40.5"
      x2="92"
      y2="46"
      stroke-width="1.5"
    />

    <!-- Beltline -->
    <line
      x1="66"
      y1="54"
      x2="104"
      y2="52"
      opacity="0.2"
      stroke-width="1"
    />

    <!-- Headlight -->
    <ellipse
      cx="111"
      cy="57"
      rx="2"
      ry="1.5"
      fill="currentColor"
      opacity="0.12"
      stroke-width="1"
    />

    <!-- Taillight -->
    <ellipse
      cx="60"
      cy="63"
      rx="1.5"
      ry="1.2"
      fill="currentColor"
      opacity="0.12"
      stroke-width="1"
    />

    <!-- Car undercarriage -->
    <path
      d="M58 68
         L64 68
         C64 63 68 60 72 60
         C76 60 80 63 80 68
         L92 68
         C92 63 96 60 100 60
         C104 60 108 63 108 68
         L113 68"
      stroke-width="2"
    />

    <!-- Car front wheel -->
    <circle
      cx="100"
      cy="68"
      r="7"
      stroke-width="2"
    />
    <circle
      cx="100"
      cy="68"
      r="3.5"
      stroke-width="1.5"
    />
    <circle
      cx="100"
      cy="68"
      r="1.2"
      fill="currentColor"
      opacity="0.3"
      stroke="none"
    />

    <!-- Car rear wheel -->
    <circle
      cx="72"
      cy="68"
      r="7"
      stroke-width="2"
    />
    <circle
      cx="72"
      cy="68"
      r="3.5"
      stroke-width="1.5"
    />
    <circle
      cx="72"
      cy="68"
      r="1.2"
      fill="currentColor"
      opacity="0.3"
      stroke="none"
    />

    <!-- Ground shadow -->
    <ellipse
      cx="70"
      cy="82"
      rx="52"
      ry="2.5"
      fill="currentColor"
      opacity="0.05"
      stroke="none"
    />

    <!-- Small "BE" badge floating above trailer -->
    <rect
      x="18"
      y="30"
      width="16"
      height="9"
      rx="3"
      fill="currentColor"
      opacity="0.07"
      stroke-width="1.5"
    />
    <text
      x="26"
      y="37"
      text-anchor="middle"
      font-size="6"
      fill="currentColor"
      opacity="0.25"
      stroke="none"
      font-weight="700"
    >BE</text>
  </svg>
</template>
